export const CssVariables = {
    headerHeight: '3.93rem',

    masterDetailsAsideWidth: '31rem',
};

export const CssColors = {
    black: '#1d1d1f',
    mainGreen: '#2D7A6C',
    secondaryGreen: '#9CE4A3',
    mainRed: '#D15843',
    mainGray: '#8C8C8C',
    inputBorderColor: '#D2D2D7',
    mainYellow: '#E3DB40',
};
